// This is an internal file with the whole palette definition.
// It is not exported as part of the package,
// and is solely a reference for other files.

/***
 * Please always use the semantic `colors` or `colorsRaw` tokens when possible.
 */
export const palette = {
  clear: "transparent",
  white: "#FFF",
  magnetic00: "#F3F7FF",
  magnetic05: "#E7EEFD",
  magnetic10: "#DBE5FB",
  magnetic20: "#BECEF0",
  magnetic30: "#9EB1DE",
  magnetic40: "#7C90C3",
  magnetic50: "#5A6DA2",
  magnetic60: "#3D4E80",
  magnetic70: "#273664",
  magnetic80: "#192550",
  magnetic90: "#101B44",
  magnetic100: "#040F3B",
  lilac00: "#F4F3FF",
  lilac10: "#F0EEFF",
  lilac20: "#E5E1FD",
  lilac30: "#D4CCFB",
  lilac40: "#BCB0F7",
  lilac50: "#A18EF0",
  lilac60: "#856CE5",
  lilac65: "#785DDC",
  lilac70: "#6C4FD4",
  lilac80: "#5538BA",
  lilac90: "#3F2590",
  lilac100: "#20124A",
  mint00: "#EDFAF0",
  mint05: "#E1F9E7",
  mint10: "#D5F8DF",
  mint20: "#BBF3CC",
  mint30: "#9EEAB7",
  mint40: "#81DBA2",
  mint50: "#66C78D",
  mint60: "#4FAF78",
  mint70: "#3B9364",
  mint75: "#34845A",
  mint80: "#2C7551",
  mint90: "#1F573D",
  mint100: "#153B2A",
  turmeric00: "#FFFCF5",
  turmeric05: "#FFF6DF",
  turmeric10: "#FEEFCA",
  turmeric20: "#FCE19F",
  turmeric30: "#F9D378",
  turmeric40: "#F2C458",
  turmeric50: "#E9B33E",
  turmeric60: "#DAA02B",
  turmeric70: "#C5891C",
  turmeric80: "#A76C11",
  turmeric90: "#7E4B0A",
  turmeric100: "#4D2A05",
  salmon00: "#FFEDEB",
  salmon05: "#FFDEDA",
  salmon10: "#FFCDC5",
  salmon20: "#FDAB9D",
  salmon30: "#FB8D79",
  salmon40: "#F7755B",
  salmon50: "#F06243",
  salmon60: "#E55430",
  salmon70: "#D44420",
  salmon80: "#BC3C17",
  salmon90: "#932E0E",
  salmon100: "#4F1907",
  silicon00: "#F8F8FA",
  silicon05: "#ECECEE",
  silicon10: "#DEDFE2",
  silicon15: "#D2D3D6",
  silicon20: "#C6C7CA",
  silicon25: "#B9BABE",
  silicon30: "#ADAEB2",
  silicon35: "#A0A1A6",
  silicon40: "#93959A",
  silicon45: "#87888E",
  silicon50: "#7A7C82",
  silicon55: "#6E7076",
  silicon60: "#62646A",
  silicon65: "#57585E",
  silicon70: "#4B4C52",
  silicon75: "#404146",
  silicon80: "#35353A",
  silicon85: "#2A2A2E",
  silicon90: "#1F1F22",
  silicon95: "#141416",
  silicon100: "#09090A",
} as const
